import React from 'react';
import { SunIcon } from 'lucide-react';
interface PortalHeaderProps {
  email: string;
  onSignOut: () => void;
}
export function PortalHeader({
  email,
  onSignOut
}: PortalHeaderProps) {
  const linkClass = 'rounded-lg px-2 py-1 font-sans text-[13px] text-navy/70 transition-colors duration-150 ease-out hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-paper';
  return <header className="border-b border-navy/10 bg-paper/90" data-id="element-189" data-mp="1w32vn7heeh82">
      <div className="mx-auto flex max-w-portal flex-wrap items-center gap-x-6 gap-y-3 px-5 py-4 sm:px-8" data-id="element-190" data-mp="20zbfuzagd0m3">
        <a href="#library" className="flex items-center gap-2 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-paper" data-id="element-191" data-mp="1n7wtqjl90jat">
          <SunIcon aria-hidden="true" className="h-4 w-4 text-sun" strokeWidth={2.5} data-id="element-192" data-mp="2jqayzjv9ng7g" />
          <span className="font-display text-[14px] font-semibold uppercase tracking-[0.14em] text-navy" data-id="element-193" data-mp="2js5n171u3ofr">
            Little Engineers
          </span>
        </a>

        <nav aria-label="Portal sections" className="flex items-center gap-1" data-id="element-194" data-mp="210bel2q24gb2">
          <a href="#library" className={linkClass} data-id="element-195" data-mp="2foocw6cmab8q">
            My Library
          </a>
          <a href="#getting-started" className={linkClass} data-id="element-196" data-mp="2awmsfx5ape7m">
            Getting Started
          </a>
        </nav>

        <div className="ml-auto flex items-center gap-4" data-id="element-197" data-mp="2on9otinl2s0j">
          <span className="hidden font-sans text-[12px] text-navy/45 sm:inline" data-id="element-198" data-mp="2kmpsghau3sfg">{email}</span>
          <button type="button" onClick={onSignOut} className="rounded-lg px-1 font-sans text-[12px] text-navy/45 underline decoration-navy/20 underline-offset-4 transition-colors duration-150 ease-out hover:text-navy hover:decoration-navy/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-paper" data-id="element-199" data-mp="2ymh3c9620sp8">
            Sign out
          </button>
        </div>
      </div>
    </header>;
}